
import React,{ useEffect } from "react";
import "./WhyChooseYou.css";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import AOS from "aos";
import "aos/dist/aos.css";


const features = [
  {
    title: "Expertise That Delivers",
    description:
      "At StarlinkLab, our seasoned experts combine years of experience with cutting-edge skills to craft scalable, impactful solutions. We go beyond services — delivering real value through innovation, industry expertise, and a strong commitment to your business success.",
    tag: "Innovative",
    special: true,
  },
  {
    title: "Industries Focused",
    description:
      "StarlinkLab delivers tailored technology solutions across diverse industries. From eCommerce, healthcare, and education to real estate, logistics, and fintech, we understand the unique challenges of each sector and craft scalable, efficient digital solutions to meet them. ",
    tag: "Scalable",
  },
  {
    title: "Commitment to Quality & Reliable and Security",
    description:
      "StarlinkLab ensures high-quality, reliable solutions with strong security. We’re dedicated to protecting your data and delivering consistent, trustworthy performance every time.",
    tag: "Secure",
    //  special: true,
  },
  {
    title: "Results That Matter",
    description:
      "Our goal is simple—your success. We focus on delivering measurable results that drive revenue, efficiency, and user engagement.At StarlinkLab, we focus on delivering measurable outcomes. Our solutions drive growth, boost efficiency, and create real impact for your business.",
    tag: "Results-Driven",
  },
  {
    title: "Seamless Collaboration & Support",
    description:
      "At StarlinkLab, we believe in building strong partnerships. Our team works closely with clients at every stage — from concept to launch — ensuring smooth communication, transparency, and unwavering support.",
    tag: "Client-Centric",
  },
];

const WhyChooseUs = () => {

   useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  return (
    <section>

  
    <div className="why-choose-us" data-aos="fade-up">
      <div>
        <div className="whyChooseFeaturesContainer">
          <div className="whychooseUsHeading">
            <h1 className="whyChooseTitle" data-aos="fade-down-right">
            Reasons To Choose Starlinklab? <ArrowCircleRightIcon/>
              {/* <span className="starlinklab">Starlinklab?</span> */}
            </h1>
          </div>

          {features.map((feature, index) => (
            <div
              key={index}
              className={`whyChoosefeatureCard ${
                feature.special ? "whyChooseSpecialCard" : ""
              }`}
               style={feature.special ? { color: "white"} : {}}
               
            >
              <h3 className="whychooseCardtitle" >{feature.title}</h3>
              <p className="whyChooseFeatureDescription">
                {feature.description}
              </p>
              <span className="feature-tag whychooseFeactureTag">
                {feature.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
  );
};


export default WhyChooseUs;
